import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function AccountsRedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // ルートページ（顧客一覧）にリダイレクト
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">リダイレクト中</h1>
        <p className="text-gray-600">メインページに移動中...</p>
        <div className="mt-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    </div>
  );
}
